import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

export interface paginationAttribute {
  totalItems: number,
  currentPage: number,
  pages: number[],
  endPage: boolean,
  pageCount: number,
  endPageNumber: number
}

@Component({
  selector: 'app-standard-pagination',
  templateUrl: './standard-pagination.component.html',
  styleUrls: ['./standard-pagination.component.css']
})
export class StandardPaginationComponent implements OnInit {
  @Input() pagination: paginationAttribute;
  @Input() backgroundColor: string;
  @Output() paginationAction = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges() {
    this.setPaginationAttributes();
  }

  setPaginationAttributes() {
    const endPageLimit = (this.pagination?.['totalItems'] / this.pagination?.['pageCount']);
    if (((endPageLimit % 1) > 0)) {
      if (Math.trunc(endPageLimit) >= 1) {
        this.pagination['endPageNumber'] = Math.trunc(endPageLimit) + 1;
      } else {
        this.pagination['endPageNumber'] = 1;
      }
    } else {
      this.pagination['endPageNumber'] = Math.trunc(endPageLimit);
    }
  }

  onPaginateChange(pageNumber: number) {
    this.paginationAction.emit(pageNumber);
  }

}
